import { environment } from '@environments/environment';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class GetFindingsService {
    // eslint-disable-next-line
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.findingSubject = new BehaviorSubject([]);
        this.findingRespSubject = new BehaviorSubject([]);
        this.findingObservable = this.findingSubject.asObservable();
        this.findingRespObservable = this.findingRespSubject.asObservable();
    }
    getFindings(analysisId) {
        return this.httpClient.get(environment.api.base + 'icrs/' + analysisId + '/observations');
    }
    setcheckMarkFinding(test) {
        this.findingSubject.next(test);
    }
    getcheckMarkFinding() {
        return this.findingObservable;
    }
}
GetFindingsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GetFindingsService_Factory() { return new GetFindingsService(i0.ɵɵinject(i1.HttpClient)); }, token: GetFindingsService, providedIn: "root" });
